import type { ReactNode } from "react";

import { Row } from "@narmi/design_system";

import styles from "./AddressRow.module.scss";

interface AddressRowProps {
  // e.g. street address, which takes most of the row
  wide: ReactNode;
  // e.g. apt/suite, which gives up space first
  narrow?: ReactNode;
  gapSize: "xs" | "m";
  className?: string;
}

const AddressRow = ({ wide, narrow, gapSize, className }: AddressRowProps) => (
  <Row gapSize={gapSize} className={className}>
    <Row.Item shrink className={styles.addressGrow}>
      {wide}
    </Row.Item>
    {narrow ? (
      <Row.Item shrink className={styles.addressShrink}>
        {narrow}
      </Row.Item>
    ) : null}
  </Row>
);

export default AddressRow;
